import type { TabItemProps } from './Tabs.types';

const TabsItem = (_: TabItemProps) => {
  return null;
};

TabsItem.displayName = 'Tabs.Item';

export default TabsItem;
